import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import ButtonStyled, {
  primary,
  secondary,
  tertiary,
  primaryInverse,
  ButtonPrimaryStyled,
  ButtonSecondaryStyled,
  ButtonSecondaryInverseStyled,
  ButtonPrimaryTransparentStyled,
  ButtonIcon,
} from "./Button.Style";
import Typografy from "../Typografy";
import Action from "../Action";
import { resolveClassNames } from "../../../utils";

const Button = (props) => {
  const {
    href,
    textStrong,
    bSize,
    elementType,
    bIcon: Icon,
    label,
    children,
    loading,
    onClick,
    className: propClassName,
  } = props;

  const type = useMemo(() => (href ? "link" : elementType), [
    elementType,
    href,
  ]);

  const labelContent = useMemo(() => label || children, [children, label]);
  const className = useMemo(
    () => resolveClassNames(propClassName, loading ? "loading" : null),
    [loading, propClassName]
  );

  const onClickHandle = useCallback(
    (evt) => {
      if (loading && elementType !== "input") {
        evt.preventDefault();
      } else if (onClick) {
        onClick(evt);
      }
    },
    [elementType, loading, onClick]
  );

  return (
    <Typografy
      {...props}
      className={className}
      as={ButtonStyled}
      textType="button"
      textSize={bSize}
      elementType={type}
      textVariant={textStrong ? "1" : "2"}
      label={null}
      onClick={onClickHandle}
    >
      {Icon && label ? (
        <span className="content-icon">
          <ButtonIcon as={Icon} /> <span>{labelContent}</span>
        </span>
      ) : (
        labelContent
      )}
    </Typografy>
  );
};

Button.defaultProps = {
  ...Action.defaultProps,
  elementType: "button",
  href: null,
  variant: primary,
  textStrong: false,
  bSize: "md",
  bIcon: null,
};

Button.propTypes = {
  ...Action.propTypes,
  href: PropTypes.string,
  variant: PropTypes.oneOf([primary, secondary, tertiary, primaryInverse]),
  textStrong: PropTypes.bool,
  bSize: PropTypes.oneOf(["sm", "md"]),
  bIcon: PropTypes.elementType,
};

export const ButtonPrimary = (props) => (
  <ButtonPrimaryStyled {...props} as={Button} />
);

export const ButtonSecondary = (props) => (
  <ButtonSecondaryStyled {...props} as={Button} />
);

export const ButtonSecondaryInverse = (props) => (
  <ButtonSecondaryInverseStyled {...props} as={Button} />
);

export const ButtonPrimaryTransparent = (props) => (
  <ButtonPrimaryTransparentStyled {...props} as={Button} />
);

export default Button;
